import { suppliosApi } from './api-service';
import axios from 'axios';

/* 
When using vue-formulate, if you don't use file component as part of a vue-formulate form, then just use v-model to something, and pull data from there
if you do use it as part of a vue-formulate form, don't use v-model, and it will pull out the URL (or whatever other string you return, maybe file ID?) and include that in the form data
*/

var buildFormData = function(formFields, file) {
    //console.log("At the start of buildFormData function");
    //console.log(formFields);
    var formData = new FormData();
    Object.entries(formFields).forEach(([name, data]) => {
        //console.log(`Going to append ${name}: ${data} to formData`);
        formData.append(name, data);  // add each k/v pair from formFields to the FormData object
    });
    formData.append('file', file);  // add the actual file to be uploaded
    //console.log("Done making formData, dumping below");
    //console.log(formData.entries());
    return formData;  
}


var splFileSlinger = function(file_category, file, progressHandler, errHandler, options, title, parentId) {
    // custom uploader to send things directly to S3 for a given tenant (from request), filename, folder
    // internally it calls Django backend to get POST parameters, then uses axios to make the POST to S3
    // MUST return a promise
    // this assumes you're using your own CustomS3File (with specified destination) and 
    //      and vue-formulate, which passes in 4 args:
    //      - file_category = string -> the 'category name' for the subclass of AbstractS3File you want to use - using this instead of dest now
    //      - OLD: dest = string - the destination in your core_files destination options (CustomS3File)
    //      - file = file object - check MDN - can get name, size, type, etc.
    //      - progressHandler = callback to report progress, should be 0-100
    //      - errHandler = callback to report error, a method that takes a single string as arg (explaining the error)
    //      - options = top-level context object from vue-formulate (not the field context, it seems...)... if it was, you could do this below:
    //          - you can set attribute of 'supplios-folder="something"' in vue template and it gets passed into vue-formulate context object
    //          - it will be in options.attributes['supplios-folder']
    //      - title = OPTIONAL title to save with this in Django backend
    //      - parentId = PK of the parent object this file is attached to, if any
    /* console.log("From splFileSlinger, dumping file, progressHandler, errHandler, options below:");
    console.log(file);
    console.log(progressHandler);
    console.log(errHandler);
    console.log(options); */
    // file here is the native File object, with standard attributes
    let filename = file.name;
    let filetype = file.type;  // the MIME type, a string like 'application/pdf'
    let filesize = file.size;  // size in bytes
    // make the call to your backend to get paramters for POSTing to S3 (signed URL, form data, policy, etc.)
    let getUploadParams = suppliosApi.files.getS3UploadUrl(file_category, filename, filetype)
        .then(response => response.data)   // getUploadParams resolves to response.data (object with keys of 'url', 'fields', 'unique', 'clean_filename', 'object_key', and 'download_url') if all was good
        .catch(err => {
            console.log('Error while getting Upload URL');
            console.log(err);
            errHandler(JSON.stringify(err));  // use the error callback, pass in a string
            return {};  // return an empty object instead of success case which returns non-empty object
        });
    // now actually do the POST to S3 
    let postToS3 = getUploadParams.then(postData => {
        /*
        postData here is a dict we got back from Django with info on how/what to POST to S3
        keys in that dict/obj are as follows:
            - url:  the URL to POST to S3
            - fields:  dict of fields to include in the POST body to S3
            - unique:  id/pk for this file, assigned by first call to django backend, part of object_key path, and we'll use it as PK
            - clean_filename:  modified (cleaned) filename from django
            - object_key:  fully built up key for this object, same as we'll use in POST to S3
            - download_url:  full URL to download the object, based on expected URL from django boto3 generate_signed_url, in case you need on front-end for things
        */
        if (!postData.url) {
            // if we don't have url here, then something went wrong getting data from backend
            errHandler("Could not get upload data, so we aborted");
            return false;
        }
        console.log("Hello from just before we do axios POST to S3, url and fields below");
        console.log(postData.url);
        console.log(postData.fields);
        // now we continue on with actually doing the upload
        // create our axios instance with most of the things, but not url... that's required when you actually call .post()
        let preppedData = buildFormData(postData.fields, file);
        let axiosConfig = {
            headers: {'Content-Type': 'multipart/form-data'},
            onUploadProgress: (progressEvent) => {
                // progressEvent is the native progress event, we figure it out as 0-100 and pass that to progressHandler from vue-formulate
                progressHandler(Math.round((progressEvent.loaded * 100) / progressEvent.total));
            },
        }
        // so we just need to call .post(url) to actually trigger the POST to S3
        return axios.post(postData.url, preppedData, axiosConfig)
            .then(response => {
                // if successful, S3 won't return much, but you need to return somethingn to vue-formulate component
                // so it can use that to send data back to my API endpoint -- so grab some stuff from original response from my backend
                console.log("Got response from S3 - dumping full response");
                console.log(response);
                let return_to_formulate = {};
                return_to_formulate['response_headers'] = response.headers;
                return_to_formulate['s3_location'] = response.headers['location'];  // all headers are lowercased and accessed via bracket notation according to axios docs
                return_to_formulate['s3_response'] = response.data;
                return_to_formulate['url'] = postData.download_url;  // vue-formulate expects a key 'url' to be returned
                return_to_formulate['object_key'] = postData.object_key;
                return_to_formulate['unique'] = postData.unique;   // the unique ID/PK for this file to be stored in DB
                return_to_formulate['clean_filename'] = postData.clean_filename;  // filename as modified by django
                return return_to_formulate;
            })
            .catch(err => errHandler(err));   // use the vue-formulate error handler callback we passed in
        // NEXT:  post back to Django with stuff (including unique ID/PK) saying "I'm done!"
        });
    // finally, now that S3 upload is complete, post back to Django with info to save about the file & create the model instance in Django 
    let postToBackend = postToS3.then(s3resp => {
        // s3resp here will be the dict you passed from prior step with s3response (nothing) and all the other stuff you added in
        let fileData = { // make sure to set defaults to correct type your API expects if they're optional
            file_category: file_category,  // same as we originally used to make first call to django
            id: s3resp.unique,  // 
            object_key: s3resp.object_key,
            filename: s3resp.clean_filename,
            filetype: filetype,  // we got this way up at the top
            filesize: filesize,  // we got this way up at the top
        };
        if (title) fileData['title'] = title;  // if we passed in a title, add it to our data to post
        if (parentId) fileData['parent'] = parentId;  // if we passed in a parentId, add it to post data, just as 'parent', not 'parent_id'
        // now actually POST to django
        return suppliosApi.files.saveS3Upload(fileData)
            .then(resp => {
                // resp here is the response from SaveS3Upload view -- just dict/obj with 'url' which is our download url, signed if necessary
                return resp.data;
            })
            .catch(err => errHandler(err));  // use the vue-formulate error handler callback we passed in
    });
    return postToBackend.then(backendResp => {
        console.log('from splFileSlinger, here is what we are returning in the final Promise');
        console.log(backendResp);
        return backendResp;
        // just another promise... to make sure we don't return something until final backend call is done... maybe unnecessary?
    })
}

// NEW VERSION DEC 3 2021

// moving Axios methods here to keep everything close together, not in api-service

const fileSlingerAxios = axios.create({   // dedicated axios instance just for stuff below
    xsrfCookieName: window?.splData?.CSRF_COOKIE_NAME || 'csrftoken',
    xsrfHeaderName: 'X-CSRFTOKEN',
    headers: {...window?.splFixedHeaders || {}}
});

const getS3UploadUrl = function(file_category, filename, filetype, otherData, config) {  // file category (class), filename, filetype to get object needed for direct-to-S3 POST upload
    let postData = {file_category: file_category, filename: filename, filetype: filetype, ...otherData}
    return fileSlingerAxios.post('/core-files/get-s3-upload-url/', postData, config);
}
const saveS3Upload = function(fileData, config) {
    // fileData should contain all the fields you API endpoint is expecting, in the correct format & defaults for empty values
    return fileSlingerAxios.post('/core-files/save-s3-upload/', fileData, config);
}
/* COMMENT OUT UNTIL YOU USE IT
const deleteS3Upload = function(file_category, file_id, config) {
    let postData = {file_category: file_category, id: file_id};
    return fileSlingerAxios.post('/core-files/delete-s3-upload/', postData, config);
} */


const asyncSplFileSlinger = async function(file_category, file, progressHandler, errHandler, options, title, parentId) {
    // NEW VERSION Dec 3 2021 - improved and using async/await
    // custom uploader to send things directly to S3 for a given tenant (from request), filename, folder
    // internally it calls Django backend to get POST parameters, then uses axios to make the POST to S3
    // MUST return a promise
    // this assumes you're using your own CustomS3File (with specified destination) and 
    //      and vue-formulate, which passes in 4 args:
    //      - file_category = string -> the 'category name' for the subclass of AbstractS3File you want to use - using this instead of dest now
    //      - OLD: dest = string - the destination in your core_files destination options (CustomS3File)
    //      - file = file object - check MDN - can get name, size, type, etc.
    //      - progressHandler = callback to report progress, should be 0-100
    //      - errHandler = callback to report error, a method that takes a single string as arg (explaining the error)
    //      - options = top-level context object from vue-formulate (not the field context, it seems...)... if it was, you could do this below:
    //          - you can set attribute of 'supplios-folder="something"' in vue template and it gets passed into vue-formulate context object
    //          - it will be in options.attributes['supplios-folder']
    //      - title = OPTIONAL title to save with this in Django backend
    //      - parentId = PK of the parent object this file is attached to, if any
    /* console.log("From splFileSlinger, dumping file, progressHandler, errHandler, options below:");
    console.log(file);
    console.log(progressHandler);
    console.log(errHandler);
    console.log(options); */
    // file here is the native File object, with standard attributes
    let filename = file.name;
    let filetype = file.type;  // the MIME type, a string like 'application/pdf' - WILL BE EMPTY STRING IF UNRECOGNIZED TYPE (CAD files, etc.)
    let filesize = file.size;  // size in bytes

    // CALL BACKEND TO GET PARAMETERS FOR POSTING TO S3 (signed URL, form data, policy, etc.)
    // if we don't have file.type here, we'll still make the call in case backend accepts that
    /*
    return from this (uploadParams) is object we got back from Django with info on how/what to POST to S3
    keys in that dict/obj are as follows:
        - url:  the URL to POST to S3
        - fields:  dict of fields to include in the POST body to S3
        - unique:  id/pk for this file, assigned by first call to django backend, part of object_key path, and we'll use it as PK
        - clean_filename:  modified (cleaned) filename from django
        - object_key:  fully built up key for this object, same as we'll use in POST to S3
        - download_url:  full URL to download the object, based on expected URL from django boto3 generate_signed_url, in case you need on front-end for things
    if error, it will return data of { error: 'Some text about the error' } - that will be in error.response.data 
    */
    try {
        const otherData = { filesize: filesize };
        const uploadParamsResponse = await getS3UploadUrl(file_category, filename, filetype, otherData);
        console.log('Got uploadParams response from backend - dumping full response', uploadParamsResponse);
        var uploadParams = uploadParamsResponse.data;
    } catch (uploadParamsError) {
        console.error('Error while calling backend to get upload URL and related params', uploadParamsError);
        const errorMsg = uploadParamsError.response?.data?.error || 'This file cannot be uploaded';  // should be object of { 'error': 'Some human-friendly error message' }
        errHandler(errorMsg);
        return;  // return here so we don't make the additional API calls
    }

    // UPLOAD TO S3
    // prep things for making S3 POST call
    // should we check to make sure we got all things from backend first?  then if not, abort?  maybe...
    let s3PostData = buildFormData(uploadParams.fields, file);
    let s3PostUrl = uploadParams.url;
    let s3PostAxiosConfig = {
        headers: {'Content-Type': 'multipart/form-data'},
        onUploadProgress: (progressEvent) => {
            // progressEvent is the native progress event, we figure it out as 0-100 and pass that to progressHandler from vue-formulate
            progressHandler(Math.round((progressEvent.loaded * 100) / progressEvent.total));
        },
    }
    try {
        var s3Response = await axios.post(s3PostUrl, s3PostData, s3PostAxiosConfig);
        console.log('Got response from S3 - dumping full response', s3Response);
        // if successful, S3 won't return much
        // check something here???  it sends response code of 204 on success
    } catch (s3UploadError) {
        console.error('Error while uploading file to S3', s3UploadError);
        errHandler('There was a problem uploading this file.');
        return; 
    }

    // TODO - should we check anything on s3Response?  At least check response code (it sends 204), basic validation of response data?

    // REPORT SUCCESSFUL UPLOAD DATA TO BACKEND TO SAVE IN DB
    // assemble things from s3 response and prior backend call to save the file (reference) in django backend
    // from vue-formulate docs: The result from the server (ie: my custom uplaoder... this function) should be a simple JSON array of objects in the format:
    let fileData = { // make sure to set defaults to correct type your API expects if they're optional
        file_category: file_category,  // passed in as arg, same as we originally used to make first call to django
        id: uploadParams.unique,  // the unique ID/PK for this file to be stored in DB
        object_key: uploadParams.object_key,  // constructed during our first call to backend (and used when posting to S3)
        filename: uploadParams.clean_filename,  // filename as modified and returned by django in first api call
        filetype: filetype,  // passed in as arg
        filesize: filesize,  // passed in as arg
    };
    if (title) fileData['title'] = title;  // if we passed in a title arg, add it to our data to post
    if (parentId) fileData['parent'] = parentId;  // if we passed in a parentId arg, add it to post data, just as 'parent', not 'parent_id'
    try {
        const saveFileResp = await saveS3Upload(fileData);  
        console.log('Got response from saving to backend:', saveFileResp);
        var savedFileObj = saveFileResp.data; // response.data will be object { id, url } - 'url' is our download url, signed if necessary so it can be accessed immediately after uploading
        return savedFileObj;  // formulate says it wants ARRAY of objects... but you weren't doing that before...
        // Dec 4 2021 - we will stay with just returning OBJECT here, not array of objects
        // that seems to make sense studying how formulate handles things, and its what you were doing before, and it works
        // you tried it with array, and it broke how you were doing things
        // if you change uploaders later (ie: not vue-formulate) then make separate one
    } catch (saveFileError) {
        console.error('Error while saving this file to backend', saveFileError);
        errHandler('There was a problem saving this file.');
        return; 
    }
}


export {
    splFileSlinger,
    asyncSplFileSlinger,
}
